<template>
  <v-card flat>
      <v-card class="_card elevation-0">
          <v-card-text class="pa-0">
              <v-btn-toggle v-model="select"
                          class="d-flex wrap elevation-0"
                          multiple>
                  <v-btn v-for="item in items"
                      :value="item.id"
                      :ripple="false"
                      :key="item.id"
                      :disabled="readonly"
                      active-class="v-btn--active v-btn-app--active"
                      :id="`buttondt_${item.id}`"
                      @click="clickhandler(`${item.id}`,{propvalue},$event,`${item.is_child}`)"
                      flat>
                      <div class="_btn-content">
                          <app-svg-icon :name="`${iconDir}/NG_${item.slug.toString().toUpperCase()}`"></app-svg-icon>
                          <span class="icon-label app-text-light">{{ item.name | capitalize }}   </span>
                          <app-svg-icon v-if="`${item.is_child}`==1" class="svgdroppdown" :name="`ui/NG_DROPDOWN`"></app-svg-icon>
                           
                        <!--  <div v-if="`${item.is_child}`==1" class="show-subcategory"  @click="clickhandler123(`${item.id}`,{propvalue},$event,`${item.is_child}`)"><app-svg-icon class="svgdroppdown" :name="`ui/NG_DROPDOWN`"></app-svg-icon> </div>-->
                       
                      </div>
                      
                  </v-btn>
                  

              </v-btn-toggle>
             
              
          </v-card-text>
      </v-card>
  </v-card>
</template>


<script>
import '../app-icons'
export default {
  name: 'app-btn-toggle-qualifications',

  props: {
    value: {
      type: Array,
      default: () => []
    },
    iconDir: String,
    propvalue:String,
    items: {
      type: Array,
      required: true
    },
    readonly: Boolean
  },

  data () {
    return {
      select: this.value || [],
      selecAllChecked: this.checkSelectAll(),
      childopt:null,
      proprvalue:this.propvalue
    }
  },
  methods: {

    clickhandler(event,typeval,evtname,is_child){
      
      if(this.proprvalue=='caregiverscategory'){
        if(!evtname.target.closest('button').classList.contains('v-btn--active')){
          var getstatus=true;
        }else{
          var getstatus=false;
        }
        const event_actions = [];
        event_actions[0]= event;
        event_actions[1]= getstatus;
        event_actions[2]= is_child;
        this.$emit('caregivemain_cat',event_actions)
        //this.$emit('caregivemain_cat',event+'='+getstatus+"="+is_child)
      }
    },
    clickSelectAll () {
      if (this.selecAllChecked) {
        this.select = []
        this.selecAllChecked = false
      } else {
        //alert();
        this.select = this.items.map(e => {
          return e.id
        })
        this.selecAllChecked = true
      }
    },
    checkSelectAll () {
      if (!Array.isArray(this.select)) {
        return false
      }
      return this.items.length === this.select.length
    }
  },
  watch: {
    value (v) {
      this.select = v
      this.selecAllChecked = this.checkSelectAll()
      
    },
    select () {
      //console.log(this.proprvalue);
    //  alert(this.select);
      this.$emit('input', this.select)
      if(this.proprvalue=='caregiverscategory')
      this.$emit('selectedcaregive', this.select)
      //if( this.proprvalue=="caregivesubcategory")
      //this.$emit('caregive_sub', this.select)
    }
  },
  mounted () {
    this.selecAllChecked = this.checkSelectAll()
  }
}
</script>

<style lang="stylus" scoped>
  .select-all
      padding 5px 0
      span
          font-weight 600
  ._card
      max-width 750px
      border none !important


      .v-card__text
          border 1px solid var(--grey_3)
          .v-item-group
              padding-top 10px
              padding-bottom 10px
      .v-btn-toggle
          background transparent
          flex-direction column
          .v-btn
              opacity 1
              height auto
              border none
              color var(--grey_2) !important
              ._btn-content
                  display flex
                  flex-direction row
                  align-items center
                  justify-content flex-start
                  min-width 100%
                  padding 8px 16px

                  .svgdroppdown
                    width 12px !important
                    height 7px !important
                  .svg-icon
                      width 20px
                      height 28px
                      margin-right 16px
              .icon-label
                  display block
                  /*text-decoration line-through*/
                  /*font-size 0.778em*/
                  font-size 1.1666rem
                  color var(--charcoal) !important
                  margin 0.2em
              &:hover
                  color var(--blue)
                  opacity 1
                  .icon-label
                      color var(--black)
              &-app--active
                  color var(--blue) !important
                  .icon-label
                      color var(--black) !important
                      text-decoration none
                  &:before
                      background-color transparent
              &:hover:before,
              &:focus:before
                  background-color transparent
              &.v-btn--disabled
                  color initial

  @media (min-width: 600px)
      ._card
          padding-top 0
          padding-bottom 0
          border-radius 0
         

          .v-card__text
              .v-item-group
                  padding-top 0
                  padding-bottom 0
          .v-btn-toggle
              flex-direction row
              flex-wrap wrap
              .v-btn
                  width 25%
                  max-width: 25%
                  min-height 128px
                  ._btn-content
                      flex-direction column
                      .svg-icon
                          width 46px
                          margin 0
                          height 48px
                  .icon-label
                      font-size 0.778em
</style>



// WEBPACK FOOTER //
// src/components/app-buttons/app-btn-toggle-caregiver.vue